// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifiedRouteImport } from './routes/verified'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as StudioRouteImport } from './routes/studio'
import { Route as RefundPolicyRouteImport } from './routes/refund-policy'
import { Route as ReferralRouteImport } from './routes/referral'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PricingsRouteImport } from './routes/pricings'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as DataDeletionRouteImport } from './routes/data-deletion'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as ComparisonRouteImport } from './routes/comparison'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as LangRouteImport } from './routes/$lang'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UseCaseIndexRouteImport } from './routes/use-case/index'
import { Route as ToolsIndexRouteImport } from './routes/tools/index'
import { Route as UseCaseInstagramStoryReplyAutomationRouteImport } from './routes/use-case/instagram-story-reply-automation'
import { Route as UseCaseInstagramDmLinkAutomationRouteImport } from './routes/use-case/instagram-dm-link-automation'
import { Route as UseCaseInstagramDmEmailCollectionRouteImport } from './routes/use-case/instagram-dm-email-collection'
import { Route as UseCaseInstagramCommentDmAutomationRouteImport } from './routes/use-case/instagram-comment-dm-automation'
import { Route as ToolsPromptVaultRouteImport } from './routes/tools/prompt-vault'
import { Route as ToolsInstagramUtmLinkGeneratorRouteImport } from './routes/tools/instagram-utm-link-generator'
import { Route as ToolsInstagramPostFormatterRouteImport } from './routes/tools/instagram-post-formatter'
import { Route as ToolsInstagramMoneyCalculatorRouteImport } from './routes/tools/instagram-money-calculator'
import { Route as ToolsInstagramLineBreakerRouteImport } from './routes/tools/instagram-line-breaker'
import { Route as ToolsInstagramLikesToFollowersCalculatorRouteImport } from './routes/tools/instagram-likes-to-followers-calculator'
import { Route as ToolsInstagramInfluencerPricingCalculatorRouteImport } from './routes/tools/instagram-influencer-pricing-calculator'
import { Route as ToolsInstagramHookGeneratorRouteImport } from './routes/tools/instagram-hook-generator'
import { Route as ToolsInstagramHashtagGeneratorRouteImport } from './routes/tools/instagram-hashtag-generator'
import { Route as ToolsInstagramGrowthTipsGeneratorRouteImport } from './routes/tools/instagram-growth-tips-generator'
import { Route as ToolsInstagramGiveawayPickerRouteImport } from './routes/tools/instagram-giveaway-picker'
import { Route as ToolsInstagramFontsGeneratorRouteImport } from './routes/tools/instagram-fonts-generator'
import { Route as ToolsInstagramFollowerRatioCalculatorRouteImport } from './routes/tools/instagram-follower-ratio-calculator'
import { Route as ToolsInstagramEngagementCalculatorRouteImport } from './routes/tools/instagram-engagement-calculator'
import { Route as ToolsInstagramEmvCalculatorRouteImport } from './routes/tools/instagram-emv-calculator'
import { Route as ToolsInstagramDmRoiCalculatorRouteImport } from './routes/tools/instagram-dm-roi-calculator'
import { Route as ToolsInstagramContentIdeasGeneratorRouteImport } from './routes/tools/instagram-content-ideas-generator'
import { Route as ToolsInstagramChatLinkGeneratorRouteImport } from './routes/tools/instagram-chat-link-generator'
import { Route as ToolsInstagramCaptionGeneratorRouteImport } from './routes/tools/instagram-caption-generator'
import { Route as ToolsInstagramBoldItalicTextRouteImport } from './routes/tools/instagram-bold-italic-text'
import { Route as ArticleSlugRouteImport } from './routes/article.$slug'
import { Route as StudioSplatRouteImport } from './routes/studio.$'
import { Route as ComparisonIndexRouteImport } from './routes/comparison/index'
import { Route as ComparisonZorchaVsZapifyProRouteImport } from './routes/comparison/zorcha-vs-zapify-pro'
import { Route as ComparisonSuperprofileVsZapifyProRouteImport } from './routes/comparison/superprofile-vs-zapify-pro'
import { Route as ComparisonReplyrushVsZapifyProRouteImport } from './routes/comparison/replyrush-vs-zapify-pro'
import { Route as ComparisonManychatVsZapifyProRouteImport } from './routes/comparison/manychat-vs-zapify-pro'
import { Route as ComparisonLinktodmVsZapifyProRouteImport } from './routes/comparison/linktodm-vs-zapify-pro'
import { Route as ComparisonLinkdmVsZapifyProRouteImport } from './routes/comparison/linkdm-vs-zapify-pro'
import { Route as ComparisonInstantdmVsZapifyProRouteImport } from './routes/comparison/instantdm-vs-zapify-pro'
import { Route as ComparisonInroVsZapifyProRouteImport } from './routes/comparison/inro-vs-zapify-pro'
import { Route as ComparisonCreatorflowVsZapifyProRouteImport } from './routes/comparison/creatorflow-vs-zapify-pro'
import { Route as LangIndexRouteImport } from './routes/$lang/index'
import { Route as LangVerifiedRouteImport } from './routes/$lang/verified'
import { Route as LangTermsRouteImport } from './routes/$lang/terms'
import { Route as LangRefundPolicyRouteImport } from './routes/$lang/refund-policy'
import { Route as LangReferralRouteImport } from './routes/$lang/referral'
import { Route as LangPrivacyRouteImport } from './routes/$lang/privacy'
import { Route as LangPricingsRouteImport } from './routes/$lang/pricings'
import { Route as LangPricingRouteImport } from './routes/$lang/pricing'
import { Route as LangDataDeletionRouteImport } from './routes/$lang/data-deletion'
import { Route as LangContactRouteImport } from './routes/$lang/contact'
import { Route as LangComparisonRouteImport } from './routes/$lang/comparison'
import { Route as LangBlogRouteImport } from './routes/$lang/blog'
import { Route as BlogCategorySlugRouteImport } from './routes/blog_.category.$slug'
import { Route as BlogAuthorSlugRouteImport } from './routes/blog_.author.$slug'
import { Route as LangUseCaseIndexRouteImport } from './routes/$lang/use-case/index'
import { Route as LangToolsIndexRouteImport } from './routes/$lang/tools/index'
import { Route as LangUseCaseInstagramStoryReplyAutomationRouteImport } from './routes/$lang/use-case/instagram-story-reply-automation'
import { Route as LangUseCaseInstagramDmLinkAutomationRouteImport } from './routes/$lang/use-case/instagram-dm-link-automation'
import { Route as LangUseCaseInstagramDmEmailCollectionRouteImport } from './routes/$lang/use-case/instagram-dm-email-collection'
import { Route as LangUseCaseInstagramCommentDmAutomationRouteImport } from './routes/$lang/use-case/instagram-comment-dm-automation'
import { Route as LangArticleSlugRouteImport } from './routes/$lang/article.$slug'
import { Route as LangComparisonZorchaVsZapifyProRouteImport } from './routes/$lang/comparison/zorcha-vs-zapify-pro'
import { Route as LangComparisonManychatVsZapifyProRouteImport } from './routes/$lang/comparison/manychat-vs-zapify-pro'
import { Route as LangComparisonLinkdmVsZapifyProRouteImport } from './routes/$lang/comparison/linkdm-vs-zapify-pro'

const VerifiedRoute = VerifiedRouteImport.update({
            id: '/verified',path: '/verified',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const StudioRoute = StudioRouteImport.update({
            id: '/studio',path: '/studio',getParentRoute: () => rootRouteImport
          })
const RefundPolicyRoute = RefundPolicyRouteImport.update({
            id: '/refund-policy',path: '/refund-policy',getParentRoute: () => rootRouteImport
          })
const ReferralRoute = ReferralRouteImport.update({
            id: '/referral',path: '/referral',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PricingsRoute = PricingsRouteImport.update({
            id: '/pricings',path: '/pricings',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const DataDeletionRoute = DataDeletionRouteImport.update({
            id: '/data-deletion',path: '/data-deletion',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const ComparisonRoute = ComparisonRouteImport.update({
            id: '/comparison',path: '/comparison',getParentRoute: () => rootRouteImport
          })
const BlogRoute = BlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const LangRoute = LangRouteImport.update({
            id: '/$lang',path: '/$lang',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const UseCaseIndexRoute = UseCaseIndexRouteImport.update({
            id: '/use-case/',path: '/use-case/',getParentRoute: () => rootRouteImport
          })
const ToolsIndexRoute = ToolsIndexRouteImport.update({
            id: '/tools/',path: '/tools/',getParentRoute: () => rootRouteImport
          })
const UseCaseInstagramStoryReplyAutomationRoute = UseCaseInstagramStoryReplyAutomationRouteImport.update({
            id: '/use-case/instagram-story-reply-automation',path: '/use-case/instagram-story-reply-automation',getParentRoute: () => rootRouteImport
          })
const UseCaseInstagramDmLinkAutomationRoute = UseCaseInstagramDmLinkAutomationRouteImport.update({
            id: '/use-case/instagram-dm-link-automation',path: '/use-case/instagram-dm-link-automation',getParentRoute: () => rootRouteImport
          })
const UseCaseInstagramDmEmailCollectionRoute = UseCaseInstagramDmEmailCollectionRouteImport.update({
            id: '/use-case/instagram-dm-email-collection',path: '/use-case/instagram-dm-email-collection',getParentRoute: () => rootRouteImport
          })
const UseCaseInstagramCommentDmAutomationRoute = UseCaseInstagramCommentDmAutomationRouteImport.update({
            id: '/use-case/instagram-comment-dm-automation',path: '/use-case/instagram-comment-dm-automation',getParentRoute: () => rootRouteImport
          })
const ToolsPromptVaultRoute = ToolsPromptVaultRouteImport.update({
            id: '/tools/prompt-vault',path: '/tools/prompt-vault',getParentRoute: () => rootRouteImport
          })
const ToolsInstagramUtmLinkGeneratorRoute = ToolsInstagramUtmLinkGeneratorRouteImport.update({
            id: '/tools/instagram-utm-link-generator',path: '/tools/instagram-utm-link-generator',getParentRoute: () => rootRouteImport
          })
const ToolsInstagramPostFormatterRoute = ToolsInstagramPostFormatterRouteImport.update({
            id: '/tools/instagram-post-formatter',path: '/tools/instagram-post-formatter',getParentRoute: () => rootRouteImport
          })
const ToolsInstagramMoneyCalculatorRoute = ToolsInstagramMoneyCalculatorRouteImport.update({
            id: '/tools/instagram-money-calculator',path: '/tools/instagram-money-calculator',getParentRoute: () => rootRouteImport
          })
const ToolsInstagramLineBreakerRoute = ToolsInstagramLineBreakerRouteImport.update({
            id: '/tools/instagram-line-breaker',path: '/tools/instagram-line-breaker',getParentRoute: () => rootRouteImport
          })
const ToolsInstagramLikesToFollowersCalculatorRoute = ToolsInstagramLikesToFollowersCalculatorRouteImport.update({
            id: '/tools/instagram-likes-to-followers-calculator',path: '/tools/instagram-likes-to-followers-calculator',getParentRoute: () => rootRouteImport
          })
const ToolsInstagramInfluencerPricingCalculatorRoute = ToolsInstagramInfluencerPricingCalculatorRouteImport.update({
            id: '/tools/instagram-influencer-pricing-calculator',path: '/tools/instagram-influencer-pricing-calculator',getParentRoute: () => rootRouteImport
          })
const ToolsInstagramHookGeneratorRoute = ToolsInstagramHookGeneratorRouteImport.update({
            id: '/tools/instagram-hook-generator',path: '/tools/instagram-hook-generator',getParentRoute: () => rootRouteImport
          })
const ToolsInstagramHashtagGeneratorRoute = ToolsInstagramHashtagGeneratorRouteImport.update({
            id: '/tools/instagram-hashtag-generator',path: '/tools/instagram-hashtag-generator',getParentRoute: () => rootRouteImport
          })
const ToolsInstagramGrowthTipsGeneratorRoute = ToolsInstagramGrowthTipsGeneratorRouteImport.update({
            id: '/tools/instagram-growth-tips-generator',path: '/tools/instagram-growth-tips-generator',getParentRoute: () => rootRouteImport
          })
const ToolsInstagramGiveawayPickerRoute = ToolsInstagramGiveawayPickerRouteImport.update({
            id: '/tools/instagram-giveaway-picker',path: '/tools/instagram-giveaway-picker',getParentRoute: () => rootRouteImport
          })
const ToolsInstagramFontsGeneratorRoute = ToolsInstagramFontsGeneratorRouteImport.update({
            id: '/tools/instagram-fonts-generator',path: '/tools/instagram-fonts-generator',getParentRoute: () => rootRouteImport
          })
const ToolsInstagramFollowerRatioCalculatorRoute = ToolsInstagramFollowerRatioCalculatorRouteImport.update({
            id: '/tools/instagram-follower-ratio-calculator',path: '/tools/instagram-follower-ratio-calculator',getParentRoute: () => rootRouteImport
          })
const ToolsInstagramEngagementCalculatorRoute = ToolsInstagramEngagementCalculatorRouteImport.update({
            id: '/tools/instagram-engagement-calculator',path: '/tools/instagram-engagement-calculator',getParentRoute: () => rootRouteImport
          })
const ToolsInstagramEmvCalculatorRoute = ToolsInstagramEmvCalculatorRouteImport.update({
            id: '/tools/instagram-emv-calculator',path: '/tools/instagram-emv-calculator',getParentRoute: () => rootRouteImport
          })
const ToolsInstagramDmRoiCalculatorRoute = ToolsInstagramDmRoiCalculatorRouteImport.update({
            id: '/tools/instagram-dm-roi-calculator',path: '/tools/instagram-dm-roi-calculator',getParentRoute: () => rootRouteImport
          })
const ToolsInstagramContentIdeasGeneratorRoute = ToolsInstagramContentIdeasGeneratorRouteImport.update({
            id: '/tools/instagram-content-ideas-generator',path: '/tools/instagram-content-ideas-generator',getParentRoute: () => rootRouteImport
          })
const ToolsInstagramChatLinkGeneratorRoute = ToolsInstagramChatLinkGeneratorRouteImport.update({
            id: '/tools/instagram-chat-link-generator',path: '/tools/instagram-chat-link-generator',getParentRoute: () => rootRouteImport
          })
const ToolsInstagramCaptionGeneratorRoute = ToolsInstagramCaptionGeneratorRouteImport.update({
            id: '/tools/instagram-caption-generator',path: '/tools/instagram-caption-generator',getParentRoute: () => rootRouteImport
          })
const ToolsInstagramBoldItalicTextRoute = ToolsInstagramBoldItalicTextRouteImport.update({
            id: '/tools/instagram-bold-italic-text',path: '/tools/instagram-bold-italic-text',getParentRoute: () => rootRouteImport
          })
const ArticleSlugRoute = ArticleSlugRouteImport.update({
            id: '/article/$slug',path: '/article/$slug',getParentRoute: () => rootRouteImport
          })
const StudioSplatRoute = StudioSplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => StudioRoute
          })
const ComparisonIndexRoute = ComparisonIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ComparisonRoute
          })
const ComparisonZorchaVsZapifyProRoute = ComparisonZorchaVsZapifyProRouteImport.update({
            id: '/zorcha-vs-zapify-pro',path: '/zorcha-vs-zapify-pro',getParentRoute: () => ComparisonRoute
          })
const ComparisonSuperprofileVsZapifyProRoute = ComparisonSuperprofileVsZapifyProRouteImport.update({
            id: '/superprofile-vs-zapify-pro',path: '/superprofile-vs-zapify-pro',getParentRoute: () => ComparisonRoute
          })
const ComparisonReplyrushVsZapifyProRoute = ComparisonReplyrushVsZapifyProRouteImport.update({
            id: '/replyrush-vs-zapify-pro',path: '/replyrush-vs-zapify-pro',getParentRoute: () => ComparisonRoute
          })
const ComparisonManychatVsZapifyProRoute = ComparisonManychatVsZapifyProRouteImport.update({
            id: '/manychat-vs-zapify-pro',path: '/manychat-vs-zapify-pro',getParentRoute: () => ComparisonRoute
          })
const ComparisonLinktodmVsZapifyProRoute = ComparisonLinktodmVsZapifyProRouteImport.update({
            id: '/linktodm-vs-zapify-pro',path: '/linktodm-vs-zapify-pro',getParentRoute: () => ComparisonRoute
          })
const ComparisonLinkdmVsZapifyProRoute = ComparisonLinkdmVsZapifyProRouteImport.update({
            id: '/linkdm-vs-zapify-pro',path: '/linkdm-vs-zapify-pro',getParentRoute: () => ComparisonRoute
          })
const ComparisonInstantdmVsZapifyProRoute = ComparisonInstantdmVsZapifyProRouteImport.update({
            id: '/instantdm-vs-zapify-pro',path: '/instantdm-vs-zapify-pro',getParentRoute: () => ComparisonRoute
          })
const ComparisonInroVsZapifyProRoute = ComparisonInroVsZapifyProRouteImport.update({
            id: '/inro-vs-zapify-pro',path: '/inro-vs-zapify-pro',getParentRoute: () => ComparisonRoute
          })
const ComparisonCreatorflowVsZapifyProRoute = ComparisonCreatorflowVsZapifyProRouteImport.update({
            id: '/creatorflow-vs-zapify-pro',path: '/creatorflow-vs-zapify-pro',getParentRoute: () => ComparisonRoute
          })
const LangIndexRoute = LangIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LangRoute
          })
const LangVerifiedRoute = LangVerifiedRouteImport.update({
            id: '/verified',path: '/verified',getParentRoute: () => LangRoute
          })
const LangTermsRoute = LangTermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => LangRoute
          })
const LangRefundPolicyRoute = LangRefundPolicyRouteImport.update({
            id: '/refund-policy',path: '/refund-policy',getParentRoute: () => LangRoute
          })
const LangReferralRoute = LangReferralRouteImport.update({
            id: '/referral',path: '/referral',getParentRoute: () => LangRoute
          })
const LangPrivacyRoute = LangPrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => LangRoute
          })
const LangPricingsRoute = LangPricingsRouteImport.update({
            id: '/pricings',path: '/pricings',getParentRoute: () => LangRoute
          })
const LangPricingRoute = LangPricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => LangRoute
          })
const LangDataDeletionRoute = LangDataDeletionRouteImport.update({
            id: '/data-deletion',path: '/data-deletion',getParentRoute: () => LangRoute
          })
const LangContactRoute = LangContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => LangRoute
          })
const LangComparisonRoute = LangComparisonRouteImport.update({
            id: '/comparison',path: '/comparison',getParentRoute: () => LangRoute
          })
const LangBlogRoute = LangBlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => LangRoute
          })
const BlogCategorySlugRoute = BlogCategorySlugRouteImport.update({
            id: '/blog_/category/$slug',path: '/blog/category/$slug',getParentRoute: () => rootRouteImport
          })
const BlogAuthorSlugRoute = BlogAuthorSlugRouteImport.update({
            id: '/blog_/author/$slug',path: '/blog/author/$slug',getParentRoute: () => rootRouteImport
          })
const LangUseCaseIndexRoute = LangUseCaseIndexRouteImport.update({
            id: '/use-case/',path: '/use-case/',getParentRoute: () => LangRoute
          })
const LangToolsIndexRoute = LangToolsIndexRouteImport.update({
            id: '/tools/',path: '/tools/',getParentRoute: () => LangRoute
          })
const LangUseCaseInstagramStoryReplyAutomationRoute = LangUseCaseInstagramStoryReplyAutomationRouteImport.update({
            id: '/use-case/instagram-story-reply-automation',path: '/use-case/instagram-story-reply-automation',getParentRoute: () => LangRoute
          })
const LangUseCaseInstagramDmLinkAutomationRoute = LangUseCaseInstagramDmLinkAutomationRouteImport.update({
            id: '/use-case/instagram-dm-link-automation',path: '/use-case/instagram-dm-link-automation',getParentRoute: () => LangRoute
          })
const LangUseCaseInstagramDmEmailCollectionRoute = LangUseCaseInstagramDmEmailCollectionRouteImport.update({
            id: '/use-case/instagram-dm-email-collection',path: '/use-case/instagram-dm-email-collection',getParentRoute: () => LangRoute
          })
const LangUseCaseInstagramCommentDmAutomationRoute = LangUseCaseInstagramCommentDmAutomationRouteImport.update({
            id: '/use-case/instagram-comment-dm-automation',path: '/use-case/instagram-comment-dm-automation',getParentRoute: () => LangRoute
          })
const LangArticleSlugRoute = LangArticleSlugRouteImport.update({
            id: '/article/$slug',path: '/article/$slug',getParentRoute: () => LangRoute
          })
const LangComparisonZorchaVsZapifyProRoute = LangComparisonZorchaVsZapifyProRouteImport.update({
            id: '/zorcha-vs-zapify-pro',path: '/zorcha-vs-zapify-pro',getParentRoute: () => LangComparisonRoute
          })
const LangComparisonManychatVsZapifyProRoute = LangComparisonManychatVsZapifyProRouteImport.update({
            id: '/manychat-vs-zapify-pro',path: '/manychat-vs-zapify-pro',getParentRoute: () => LangComparisonRoute
          })
const LangComparisonLinkdmVsZapifyProRoute = LangComparisonLinkdmVsZapifyProRouteImport.update({
            id: '/linkdm-vs-zapify-pro',path: '/linkdm-vs-zapify-pro',getParentRoute: () => LangComparisonRoute
          })





const LangComparisonRouteChildren = {
  LangComparisonLinkdmVsZapifyProRoute: LangComparisonLinkdmVsZapifyProRoute,LangComparisonManychatVsZapifyProRoute: LangComparisonManychatVsZapifyProRoute,LangComparisonZorchaVsZapifyProRoute: LangComparisonZorchaVsZapifyProRoute
}

const LangComparisonRouteWithChildren = LangComparisonRoute._addFileChildren(LangComparisonRouteChildren)



const LangRouteChildren = {
  LangBlogRoute: LangBlogRoute,LangComparisonRoute: LangComparisonRouteWithChildren,LangContactRoute: LangContactRoute,LangDataDeletionRoute: LangDataDeletionRoute,LangPricingRoute: LangPricingRoute,LangPricingsRoute: LangPricingsRoute,LangPrivacyRoute: LangPrivacyRoute,LangReferralRoute: LangReferralRoute,LangRefundPolicyRoute: LangRefundPolicyRoute,LangTermsRoute: LangTermsRoute,LangVerifiedRoute: LangVerifiedRoute,LangIndexRoute: LangIndexRoute,LangArticleSlugRoute: LangArticleSlugRoute,LangUseCaseInstagramCommentDmAutomationRoute: LangUseCaseInstagramCommentDmAutomationRoute,LangUseCaseInstagramDmEmailCollectionRoute: LangUseCaseInstagramDmEmailCollectionRoute,LangUseCaseInstagramDmLinkAutomationRoute: LangUseCaseInstagramDmLinkAutomationRoute,LangUseCaseInstagramStoryReplyAutomationRoute: LangUseCaseInstagramStoryReplyAutomationRoute,LangToolsIndexRoute: LangToolsIndexRoute,LangUseCaseIndexRoute: LangUseCaseIndexRoute
}

const LangRouteWithChildren = LangRoute._addFileChildren(LangRouteChildren)




const ComparisonRouteChildren = {
  ComparisonCreatorflowVsZapifyProRoute: ComparisonCreatorflowVsZapifyProRoute,ComparisonInroVsZapifyProRoute: ComparisonInroVsZapifyProRoute,ComparisonInstantdmVsZapifyProRoute: ComparisonInstantdmVsZapifyProRoute,ComparisonLinkdmVsZapifyProRoute: ComparisonLinkdmVsZapifyProRoute,ComparisonLinktodmVsZapifyProRoute: ComparisonLinktodmVsZapifyProRoute,ComparisonManychatVsZapifyProRoute: ComparisonManychatVsZapifyProRoute,ComparisonReplyrushVsZapifyProRoute: ComparisonReplyrushVsZapifyProRoute,ComparisonSuperprofileVsZapifyProRoute: ComparisonSuperprofileVsZapifyProRoute,ComparisonZorchaVsZapifyProRoute: ComparisonZorchaVsZapifyProRoute,ComparisonIndexRoute: ComparisonIndexRoute
}

const ComparisonRouteWithChildren = ComparisonRoute._addFileChildren(ComparisonRouteChildren)




const StudioRouteChildren = {
  StudioSplatRoute: StudioSplatRoute
}

const StudioRouteWithChildren = StudioRoute._addFileChildren(StudioRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,LangRoute: LangRouteWithChildren,BlogRoute: BlogRoute,ComparisonRoute: ComparisonRouteWithChildren,ContactRoute: ContactRoute,DataDeletionRoute: DataDeletionRoute,PricingRoute: PricingRoute,PricingsRoute: PricingsRoute,PrivacyRoute: PrivacyRoute,ReferralRoute: ReferralRoute,RefundPolicyRoute: RefundPolicyRoute,StudioRoute: StudioRouteWithChildren,TermsRoute: TermsRoute,VerifiedRoute: VerifiedRoute,ArticleSlugRoute: ArticleSlugRoute,ToolsInstagramBoldItalicTextRoute: ToolsInstagramBoldItalicTextRoute,ToolsInstagramCaptionGeneratorRoute: ToolsInstagramCaptionGeneratorRoute,ToolsInstagramChatLinkGeneratorRoute: ToolsInstagramChatLinkGeneratorRoute,ToolsInstagramContentIdeasGeneratorRoute: ToolsInstagramContentIdeasGeneratorRoute,ToolsInstagramDmRoiCalculatorRoute: ToolsInstagramDmRoiCalculatorRoute,ToolsInstagramEmvCalculatorRoute: ToolsInstagramEmvCalculatorRoute,ToolsInstagramEngagementCalculatorRoute: ToolsInstagramEngagementCalculatorRoute,ToolsInstagramFollowerRatioCalculatorRoute: ToolsInstagramFollowerRatioCalculatorRoute,ToolsInstagramFontsGeneratorRoute: ToolsInstagramFontsGeneratorRoute,ToolsInstagramGiveawayPickerRoute: ToolsInstagramGiveawayPickerRoute,ToolsInstagramGrowthTipsGeneratorRoute: ToolsInstagramGrowthTipsGeneratorRoute,ToolsInstagramHashtagGeneratorRoute: ToolsInstagramHashtagGeneratorRoute,ToolsInstagramHookGeneratorRoute: ToolsInstagramHookGeneratorRoute,ToolsInstagramInfluencerPricingCalculatorRoute: ToolsInstagramInfluencerPricingCalculatorRoute,ToolsInstagramLikesToFollowersCalculatorRoute: ToolsInstagramLikesToFollowersCalculatorRoute,ToolsInstagramLineBreakerRoute: ToolsInstagramLineBreakerRoute,ToolsInstagramMoneyCalculatorRoute: ToolsInstagramMoneyCalculatorRoute,ToolsInstagramPostFormatterRoute: ToolsInstagramPostFormatterRoute,ToolsInstagramUtmLinkGeneratorRoute: ToolsInstagramUtmLinkGeneratorRoute,ToolsPromptVaultRoute: ToolsPromptVaultRoute,UseCaseInstagramCommentDmAutomationRoute: UseCaseInstagramCommentDmAutomationRoute,UseCaseInstagramDmEmailCollectionRoute: UseCaseInstagramDmEmailCollectionRoute,UseCaseInstagramDmLinkAutomationRoute: UseCaseInstagramDmLinkAutomationRoute,UseCaseInstagramStoryReplyAutomationRoute: UseCaseInstagramStoryReplyAutomationRoute,ToolsIndexRoute: ToolsIndexRoute,UseCaseIndexRoute: UseCaseIndexRoute,BlogAuthorSlugRoute: BlogAuthorSlugRoute,BlogCategorySlugRoute: BlogCategorySlugRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)